import React from 'react'
import { Box } from '@mui/material'
import Header from './Header'
import Sidebar from './Sidebar'
import { PageHeaderProvider, PageHeaderSlot } from '../../contexts/PageHeaderContext'

/**
 * App shell: header (top) + body row (sidebar left | main content right).
 * Sidebar and main each scroll independently; the page does not scroll as a whole.
 */
const AppLayout = ({ sidebarOpen, onSidebarToggle, children }) => {
  return (
    <Box className="app-container">
      <Box component="header" className="app-header-slot" sx={{ flexShrink: 0 }}>
        <Header onMenuClick={onSidebarToggle} />
      </Box>

      <Box className="app-body">
        <Sidebar open={sidebarOpen} onToggle={onSidebarToggle} />
        <PageHeaderProvider>
          <Box component="main" className="main-content">
            <PageHeaderSlot />
            <Box className="main-content-scroll">{children}</Box>
          </Box>
        </PageHeaderProvider>
      </Box>
    </Box>
  )
}

export default AppLayout
